import { LocalStorageService, StorageService } from '../../platform/StorageService';
import { ActiveObject, resolve } from '../Container';
import { EditorModeInfo } from './EditorModeInfo';
import { EditorSession } from './EditorSession';
import { GridSettingsWidget } from './GridSettingsWidget';
import { GridSystem } from './GridSystem';
import { MyRoleInfo } from './MyRoleInfo';
import { WidgetManager } from './workspace/widgets/WidgetManager';

const scaleToSize = [
    [Math.pow(2, -4), 800],
    [Math.pow(2, -3), 400],
    [Math.pow(2, -2), 200],
    [Math.pow(2, -1), 100],
    [Math.pow(2, 0), 50],
    [Math.pow(2, 1), 20],
    [Math.pow(2, 2), 10],
    [Math.pow(2, 3), 5],
];

export class GridMechanics extends ActiveObject {

    @resolve(EditorSession) private session!: EditorSession;
    @resolve(GridSystem) private grid!: GridSystem;
    @resolve(LocalStorageService) private localData!: StorageService;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start() {
        this.burden(
            this.grid.observe(this.saveSettings),
            this.session.observe(EditorModeInfo, this.realizeWidgetIfApplicable),
            this.session.observe(MyRoleInfo, this.realizeWidgetIfApplicable),
        );
        this.loadSettings();
        this.realizeWidgetIfApplicable();
    }

    private saveSettings = () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { enabled, ...state } = this.grid.getState();
        this.localData.put('deqo/editor/grid3', state);
    };

    private loadSettings = () => {
        const gs = this.localData.get('deqo/editor/grid3');
        if (gs) {
            this.grid.configure(gs);
        }
    };

    private realizeWidgetIfApplicable = () => {

        this.widgets.delete('grid');

        if (!this.session.get(MyRoleInfo).canParticipate) return;
        if (this.session.get(EditorModeInfo).id !== 'design') return;

        const dock = this.widgets.createContainer();
        dock.name = 'grid';
        dock.weight = 400;
        dock.style = 'floatWithLines';
        dock.position = ['docked', 'bottomLeft', 'inline'];

        dock.add(this.widgets.createPopout({
            image: 'deqo://icons/i8/grid',
            text: 'Grid Settings',
            ui: GridSettingsWidget
        }));

        this.widgets.add(dock);
    };
}
